export default "__VITE_ASSET__BvWzSBrq__"